<template>


  <b-container v-if="processdate(LOI.LOIDate) <= processdate('2025-01-01')"  >
    <b-row>
        <b-col>
          <!-- <b-btn @click="hideModal">Close Me</b-btn> -->
          <div class="print-button-wrap">
            <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
          </div>
          <!-- <button v-print="'#printMe'">Print Application</button> -->
        </b-col>
      </b-row>
  
      <div id="printLOI">
        <!-- <div class="application-view"> -->
        <div style="margin-left:70px;margin-right:40px;margin-top:50px">
          <table
            width="100%"
            style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
          >
            <tr>
              <td
                width="20%"
                style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
              >
                <img style="width:140px;margin-top:10px;" src="@/assets/images/MSOBC-CMRClogo-1.jpg" />
              </td>
              <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
                <div style="text-align:center">
                  <span
                    style="font-size:15.0pt;font-weight:bold;"
                    v-if="LOI.Division!='Konkan'"
                  >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित</span>
                  
                  <br v-if="LOI.Division=='Konkan'" />
                  <span
                  style="font-size:15.0pt;font-weight:bold;"
                  v-if="LOI.Division=='Konkan'"
                >शामराव पेजे कोकण इतर मागासवर्ग आर्थिक विकास महामंडळ मर्यादित</span>
                <br v-if="LOI.Division=='Konkan'" />
                <span
                  style="font-size:13.0pt;font-weight:normal;"
                  v-if="LOI.Division=='Konkan'"
                >(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)</span>
                  <br v-if="LOI.Division=='Konkan'" />
                  <span style="font-size:13.0pt;font-weight:normal;">(महाराष्ट्र शासनाचा उपक्रम)</span><br/>
                  <!-- <span style="font-size:14.0pt;font-weight:bold;">उपकंपनी</span> -->
                  
                  <!-- <span
                    style="font-size:14.0pt;font-weight:bold;"
                  >जगद्ज्योती महात्मा बसवेश्वर आर्थिक विकास महामंडळ</span>
                  <br>
                  <span
                    style="font-size:14.0pt;font-weight:bold;"
                  >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span> -->
                
                  <span
                    style="font-size:12.0pt;font-weight:normal;"
                  >प्रशासकीय भवन, ४ था मजला, रामकृष्ण चेंबूरकर मार्ग, चेंबूर, मुंबई - ४०० ०७१.</span>
                  <br />
                </div>
                <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
                <span style="font-size:11.0pt;font-weight:normal;">०२२-२५२९ ९६८५</span>
                <!-- <span style="font-size:11.0pt;float:right">
                  <span style="font-weight:bold;">फॅक्स:</span>०२२-२५२२ ९२१९
                </span> -->
                <br />
                <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
                <span style="font-size:11.0pt;font-weight:bold;">www.msobcfdc.org</span>
                <span style="font-size:11.0pt;float:right">
                  <span style="font-size:11.0pt;font-weight:bold;">ई-मेल:</span>
                <span style="font-size:11.0pt;font-weight:normal;">homsobcfdc@gmail.com</span><br/>
                <span style="font-size:11.0pt;font-weight:bold;">CIN:</span>
                <span style="font-size:11.0pt;font-weight:normal;">U74999MH1999SGC119586</span><br/>
                  
                </span>
                <span style="font-size:11.0pt;float:right">
                  
                </span>
                
              </td>
              <!-- <td
                width="20%"
                style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
              >
                <img style="width:140px;margin-top:10px;" src="@/assets/images/logoright.png" />
              </td> -->
            </tr>
          </table>
         
  
          <div style="margin-bottom: 50px;margin-top: 20px;">
            <p
              style="font-size: 17pt;text-align: center;margin-bottom:5px"
              v-if="!LOI.IsExtended"
            >LOI/पात्रता प्रमाणपत्र</p>
            <p
              style="font-size: 17pt;text-align: center;margin-bottom:5px"
              v-if="LOI.IsExtended"
            >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
           
            <p
              style="font-size: 17pt;text-align: center;"
              
            >महिला स्वयंसिध्दी व्याज परतावा योजना
          </p>
           
  
            <table style="width:50%;margin-top:15px;font-size:12pt;margin-left:auto">
              <tr>
                <td>
                  <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                  <span
                    style="font-weight: bold;"
                    v-if="LOI.IsExtended"
                  >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
                </td>
                <td>
                  <span>{{LOI.LOINumber}}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="font-weight: bold;">दिनांक:</span>
                </td>
                <td>
                  <span>{{LOI.LOIDate}}</span>
                </td>
              </tr>
              <tr />
              <tr>
                <td>
                  <span style="font-weight: bold;">अर्ज क्रमांक:</span>
                </td>
                <td>
                  <span>{{LOI.LoanApplicationNo}}</span>
                </td>
              </tr>
              <tr />
            </table>
            <span style="font-size:12.0pt;">प्रति,</span>
            <br />
            <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
              <tr style="width:80%">
                <col />
                <td>
                  <table style="margin-left:0px">
                    <tr>
                      <td style="font-size:12.0pt;font-weight: bold;width:15%">श्री:</td>
                     
                      <td>
                        <span style="font-size:12.0pt;">{{personalDetails.GroupName}}</span>
                      </td>
                    </tr>
                    <tr />
                    <tr>
                      <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                      <td>
                        <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                      </td>
                    </tr>
                    <tr />
                  </table>
                </td>
                <!-- <td>
                  <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
                </td> -->
              </tr>
            </table>
            <br />
            <!-- prati ends -->
  
            <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
              <span style="font-size:12.0pt;">
                प्रिय अध्यक्ष ,
                <br/>
               <b> {{personalDetails.GroupName}}</b>
               
                <br />आपणास कळविण्यात येते की, महामंडळाच्या
                <span >महिला स्वयंसिध्दी व्याज परतावा </span>
  
              
              </span>
              <span style="font-size:12.0pt;">
                योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार आपल्या {{personalDetails.GroupName}} या बचत गटास
                 हे प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे;
              </span>
            </div>
            <!-- priy ends -->
  
            <div style="display: block; margin-left:50%;text-align:center;align:right">
              <span style="font-weight:bold;font-size:12.0pt">Sd/-</span>
              <br />
              <span style="font-size:12.0pt;">महाव्यवस्थापक</span>
              <br />
              <span
                style="font-size:12.0pt;"
              >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्या</span>
              <br />
            </div>
            <!-- vyav-s ends -->
  
            <div style="margin-top: 25px; margin-bottom: 25px;" >
              <p
                style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
              >महामंडळाच्या अटी व शर्ती</p>
  
              <p style="margin-bottom: 2px;font-size:12.0pt;">
                १. सदर हेतू प्रमाणपत्र (LOI) हे केवळ दि. {{LOI.LOIValidTill}} या तारखेपर्यंत एक वर्ष कालावधीकरीता वैध राहील.  दाखल केलेल्या अर्जांची वैधता सदर दिनांकानंतर त्या वर्षाकरीता संपुष्टात येईल.
               
              </p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >२. बचत गटातील सदस्यांनी CMRC मार्फत नमुद केलेली अर्जातील माहिती जाणून-बुजून लपविण्याचा प्रयत्न केल्यास तसेच ते खोटे आढळून आल्यास, महामंडळ त्यांची कर्ज सवलत रद्द करुन देण्यात आलेली रक्कम एकरक्कमी वसूल करण्यात येईल.याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका समवेत भारतीय रिझर्व्ह बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेडयुल्ड / मल्टीशेडयुल्ड इ. बँकेमध्ये अर्जदाराने पात्रता प्रमाणपत्राद्वारे कर्ज मागणी करावी.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >४. पात्रता प्रमाणपत्राच्या दिनांकापूर्वी बँकेने मंजूर केलेल्या कर्ज प्रकरणात सदर योजनेंतर्गत व्याजाच्या परताव्याचा लाभ घेता येणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >५. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल.  परतफेड कालावधी हा बँकेचा पहिला हफ्ता (EMI) देय असणाऱ्या तारखेपासून पकडला जाईल.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >६. सदर योजना ही मुदत कर्जासाठी लागू असून C.C. (कॅश क्रेडिट) व O.D. (Overdraft) करीता लागू राहणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >७. अनियमित तसेच, थकीत हप्त्यापैकी भरणा केलेल्या थकीत रक्कमेपैकी, फक्त नियमित होणाऱ्या हप्त्याच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >८. संबंधीत CMRC च्या शिफारशीनुसार महामंडळाच्या प्राप्त LOI च्या अनुषंगाने बँक मंजुरीनंतर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड करणे अनिवार्य आहे.परंतु, जर बँकेचे मंजूरी आदेश वेबपोर्टलवर अपलोड केले नाहीत तर संबंधीत बचत गट योजनेस पात्र ठरणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >९. बँकेतून घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर गट हा व्याज रक्कमेकरीताच पात्र असेल.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >१०. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही, कोणत्याही कारणासाठी महामंडळाविरुध्द नुकसान भरपाईचा हक्क राहणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >११. व्याज रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्राप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल.  बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली रक्कम वगळता दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            </div>
            
            <!-- ati ends -->
  
            <div style="display: block; margin-left:50%;text-align:center;align:right">
              <span style="font-weight:bold;font-size:12pt">Sd/-</span>
              <br />
              <span style="font-size:12.0pt">महाव्यवस्थापक</span>
              <br />
              <span
                style="font-size:12.0pt"
              >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्या</span>
              <br />
            </div>
            <!-- vyav-s ends -->
            <!-- <div style="float:center">
              <qr-code 
                  :text=qrtext
                  size="100"
                  error-level="H">
              </qr-code>
            </div>-->
          </div>
          <!-- lio ends -->
        </div>
      </div>
       </b-container>
  
  
  
    
    <b-container v-else-if="processdate(LOI.LOIDate) >= processdate('2025-01-02') && processdate(LOI.LOIDate) <= processdate('2025-04-21')">
      <b-row>
        <b-col>
          <!-- <b-btn @click="hideModal">Close Me</b-btn> -->
          <div class="print-button-wrap">
            <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
          </div>
          <!-- <button v-print="'#printMe'">Print Application</button> -->
        </b-col>
      </b-row>
  
      <div id="printLOI">
        <!-- <div class="application-view"> -->
        <div style="margin-left:70px;margin-right:40px;margin-top:50px">
          <table
            width="100%"
            style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
          >
            <tr>
              <td
                width="20%"
                style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
              >
                <img style="width:140px;margin-top:10px;" src="@/assets/images/MSOBC-CMRClogo-1.jpg" />
              </td>
              <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
                <div style="text-align:center">
                  <span
                    style="font-size:15.0pt;font-weight:bold;"
                    v-if="LOI.Division!='Konkan'"
                  >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित</span>
                  
                  <br v-if="LOI.Division=='Konkan'" />
                  <span
                  style="font-size:15.0pt;font-weight:bold;"
                  v-if="LOI.Division=='Konkan'"
                >शामराव पेजे कोकण इतर मागासवर्ग आर्थिक विकास महामंडळ मर्यादित</span>
                <br v-if="LOI.Division=='Konkan'" />
                <span
                  style="font-size:13.0pt;font-weight:normal;"
                  v-if="LOI.Division=='Konkan'"
                >(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)</span>
                  <br v-if="LOI.Division=='Konkan'" />
                  <span style="font-size:13.0pt;font-weight:normal;">(महाराष्ट्र शासनाचा उपक्रम)</span><br/>
                  <!-- <span style="font-size:14.0pt;font-weight:bold;">उपकंपनी</span> -->
                  
                  <!-- <span
                    style="font-size:14.0pt;font-weight:bold;"
                  >जगद्ज्योती महात्मा बसवेश्वर आर्थिक विकास महामंडळ</span>
                  <br>
                  <span
                    style="font-size:14.0pt;font-weight:bold;"
                  >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span> -->
                
                  <span
                    style="font-size:12.0pt;font-weight:normal;"
                  >प्रशासकीय भवन, ४ था मजला, रामकृष्ण चेंबूरकर मार्ग, चेंबूर, मुंबई - ४०० ०७१.</span>
                  <br />
                </div>
                <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
                <span style="font-size:11.0pt;font-weight:normal;">०२२-२५२९ ९६८५</span>
                <!-- <span style="font-size:11.0pt;float:right">
                  <span style="font-weight:bold;">फॅक्स:</span>०२२-२५२२ ९२१९
                </span> -->
                <br />
                <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
                <span style="font-size:11.0pt;font-weight:bold;">www.msobcfdc.org</span>
                <span style="font-size:11.0pt;float:right">
                  <span style="font-size:11.0pt;font-weight:bold;">ई-मेल:</span>
                <span style="font-size:11.0pt;font-weight:normal;">homsobcfdc@gmail.com</span><br/>
                <span style="font-size:11.0pt;font-weight:bold;">CIN:</span>
                <span style="font-size:11.0pt;font-weight:normal;">U74999MH1999SGC119586</span><br/>
                  
                </span>
                <span style="font-size:11.0pt;float:right">
                  
                </span>
                
              </td>
              <!-- <td
                width="20%"
                style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
              >
                <img style="width:140px;margin-top:10px;" src="@/assets/images/logoright.png" />
              </td> -->
            </tr>
          </table>
         
  
          <div style="margin-bottom: 50px;margin-top: 20px;">
            <p
              style="font-size: 17pt;text-align: center;margin-bottom:5px"
              v-if="!LOI.IsExtended"
            >LOI/पात्रता प्रमाणपत्र</p>
            <p
              style="font-size: 17pt;text-align: center;margin-bottom:5px"
              v-if="LOI.IsExtended"
            >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
           
            <p
              style="font-size: 17pt;text-align: center;"
              
            >महिला स्वयंसिध्दी व्याज परतावा योजना
          </p>
           
  
            <table style="width:50%;margin-top:15px;font-size:12pt;margin-left:auto">
              <tr>
                <td>
                  <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                  <span
                    style="font-weight: bold;"
                    v-if="LOI.IsExtended"
                  >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
                </td>
                <td>
                  <span>{{LOI.LOINumber}}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="font-weight: bold;">दिनांक:</span>
                </td>
                <td>
                  <span>{{LOI.LOIDate}}</span>
                </td>
              </tr>
              <tr />
              <tr>
                <td>
                  <span style="font-weight: bold;">अर्ज क्रमांक:</span>
                </td>
                <td>
                  <span>{{LOI.LoanApplicationNo}}</span>
                </td>
              </tr>
              <tr />
            </table>
            <span style="font-size:12.0pt;">प्रति,</span>
            <br />
            <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
              <tr style="width:80%">
                <col />
                <td>
                  <table style="margin-left:0px">
                    <tr>
                      <td style="font-size:12.0pt;font-weight: bold;width:15%">श्री:</td>
                     
                      <td>
                        <span style="font-size:12.0pt;">{{personalDetails.GroupName}}</span>
                      </td>
                    </tr>
                    <tr />
                    <tr>
                      <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                      <td>
                        <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                      </td>
                    </tr>
                    <tr />
                  </table>
                </td>
                <!-- <td>
                  <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
                </td> -->
              </tr>
            </table>
            <br />
            <!-- prati ends -->
  
            <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
              <span style="font-size:12.0pt;">
                प्रिय अध्यक्ष ,
                <br/>
               <b> {{personalDetails.GroupName}}</b>
               
                <br />आपण, महामंडळाच्या  
                <span >महिला स्वयंसिद्धी व्याज परतावा </span>
  
              
              </span>
              <span style="font-size:12.0pt;">
                योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपल्या ऑनलाईन अर्जानुसार {{personalDetails.GroupName}} या बचत गटास आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
              </span>
            </div>
            <!-- priy ends -->
  
            
            <!-- vyav-s ends -->
  
            <!-- <div style="margin-top: 25px; margin-bottom: 25px;" >
              <p
                style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
              >महामंडळाच्या अटी व शर्ती</p> -->
  
              <p style="margin-bottom: 2px;font-size:12.0pt;">
                १. सदर पात्रता प्रमाणपत्र (LOI) हे दि. {{LOI.LOIValidTill}} या तारखेपर्यंत एक वर्ष कालावधीकरीता वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता त्या वर्षाकरीता संपुष्टात येईल.  
              </p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >२. बचत गटातील सदस्यांनी CMRC मार्फत नमुद केलेली अर्जातील माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची महिला स्वयंसिद्धी कर्ज व्याज परतावा योजनेतील कर्ज सवलत रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.  याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड इ. बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज मंजूर करुन घ्यावे. सदरची योजना ही मुदत कर्जासाठी लागु असुन C.C (कॅश क्रेडीट) व O.D (Overdraft) करीता लागु राहणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >५. संबंधित CMRC च्या शिफारशीनुसार महामंडळाच्या प्राप्त पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे. पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत बचत गट योजनेस पात्र ठरणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >६. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर गट हा व्याजपरतावा रक्कमेकरीताच पात्र असेल. इतर मागास प्रवर्गातील किमान 50% महिलांचा समावेश असलेल्या पात्र महिला बचत गटास प्रथम टप्प्यात रु.5.00 लक्षपर्यंत कर्ज बँकेकडून उपलब्ध करुन घेण्यास मान्यता देण्यात येईल व प्रथम टप्प्यातील कर्ज नियमित परतफेडीनंतर सदर बचत गट द्वितीय टप्प्यात रु.10.00 लक्ष पर्यंत कर्ज बँकेकडून मंजूर करुन घेण्यास पात्र होईल.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >७. व्याज परतावा रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल. बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >८. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >९. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. वरील अटी व शर्ती सुधारीत करणे, फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
              <!-- <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >१०. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही, कोणत्याही कारणासाठी महामंडळाविरुध्द नुकसान भरपाईचा हक्क राहणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >११. व्याज रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्राप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल.  बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली रक्कम वगळता दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            </div> -->
            
            <!-- ati ends -->
  
            <div style="display: block; margin-left:50%;text-align:center; ">
              <!-- <span style="font-weight:bold;font-size:12.0pt">Sd/-</span> -->
              <br />
              <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/>
              <span style="font-size:12.0pt;">(आनंद अर्जुन माळी)</span><br/>
              <span style="font-size:12.0pt;">व्यवस्थापकीय संचालक</span>
              <br />
              <span
                style="font-size:12.0pt;"
              >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्या</span>
              <br />
            </div>
            <!-- vyav-s ends -->
            <!-- <div style="float:center">
              <qr-code 
                  :text=qrtext
                  size="100"
                  error-level="H">
              </qr-code>
            </div>-->
          </div>
          <!-- lio ends -->
        </div>
      </div>
  
    </b-container>
  
  
  
    <b-container v-else >
      <b-row>
        <b-col>
          <!-- <b-btn @click="hideModal">Close Me</b-btn> -->
          <div class="print-button-wrap">
            <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
          </div>
          <!-- <button v-print="'#printMe'">Print Application</button> -->
        </b-col>
      </b-row>
  
      <div id="printLOI">
        <!-- <div class="application-view"> -->
        <div style="margin-left:70px;margin-right:40px;margin-top:50px">
          <table
            width="100%"
            style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
          >
            <tr>
              <td
                width="20%"
                style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
              >
                <img style="width:140px;margin-top:10px;" src="@/assets/images/MSOBC-CMRClogo-1.jpg" />
              </td>
              <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
                <div style="text-align:center">
                  <span
                    style="font-size:15.0pt;font-weight:bold;"
                    v-if="LOI.Division!='Konkan'"
                  >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित</span>
                  
                  <br v-if="LOI.Division=='Konkan'" />
                  <span
                  style="font-size:15.0pt;font-weight:bold;"
                  v-if="LOI.Division=='Konkan'"
                >शामराव पेजे कोकण इतर मागासवर्ग आर्थिक विकास महामंडळ मर्यादित</span>
                <br v-if="LOI.Division=='Konkan'" />
                <span
                  style="font-size:13.0pt;font-weight:normal;"
                  v-if="LOI.Division=='Konkan'"
                >(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)</span>
                  <br v-if="LOI.Division=='Konkan'" />
                  <span style="font-size:13.0pt;font-weight:normal;">(महाराष्ट्र शासनाचा उपक्रम)</span><br/>
                  <!-- <span style="font-size:14.0pt;font-weight:bold;">उपकंपनी</span> -->
                  
                  <!-- <span
                    style="font-size:14.0pt;font-weight:bold;"
                  >जगद्ज्योती महात्मा बसवेश्वर आर्थिक विकास महामंडळ</span>
                  <br>
                  <span
                    style="font-size:14.0pt;font-weight:bold;"
                  >संत काशिबा गुरव युवा आर्थिक विकास महामंडळ</span> -->
                
                  <span
                    style="font-size:12.0pt;font-weight:normal;"
                  >प्रशासकीय भवन, ४ था मजला, रामकृष्ण चेंबूरकर मार्ग, चेंबूर, मुंबई - ४०० ०७१.</span>
                  <br />
                </div>
                <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
                <span style="font-size:11.0pt;font-weight:normal;">०२२-२५२९ ९६८५</span>
                <!-- <span style="font-size:11.0pt;float:right">
                  <span style="font-weight:bold;">फॅक्स:</span>०२२-२५२२ ९२१९
                </span> -->
                <br />
                <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
                <span style="font-size:11.0pt;font-weight:bold;">www.msobcfdc.org</span>
                <span style="font-size:11.0pt;float:right">
                  <span style="font-size:11.0pt;font-weight:bold;">ई-मेल:</span>
                <span style="font-size:11.0pt;font-weight:normal;">homsobcfdc@gmail.com</span><br/>
                <span style="font-size:11.0pt;font-weight:bold;">CIN:</span>
                <span style="font-size:11.0pt;font-weight:normal;">U74999MH1999SGC119586</span><br/>
                  
                </span>
                <span style="font-size:11.0pt;float:right">
                  
                </span>
                
              </td>
              <!-- <td
                width="20%"
                style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;"
              >
                <img style="width:140px;margin-top:10px;" src="@/assets/images/logoright.png" />
              </td> -->
            </tr>
          </table>
         
  
          <div style="margin-bottom: 50px;margin-top: 20px;">
            <p
              style="font-size: 17pt;text-align: center;margin-bottom:5px"
              v-if="!LOI.IsExtended"
            >LOI/पात्रता प्रमाणपत्र</p>
            <p
              style="font-size: 17pt;text-align: center;margin-bottom:5px"
              v-if="LOI.IsExtended"
            >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
           
            <p
              style="font-size: 17pt;text-align: center;"
              
            >महिला स्वयंसिध्दी व्याज परतावा योजना
          </p>
           
  
            <table style="width:50%;margin-top:15px;font-size:12pt;margin-left:auto">
              <tr>
                <td>
                  <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                  <span
                    style="font-weight: bold;"
                    v-if="LOI.IsExtended"
                  >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
                </td>
                <td>
                  <span>{{LOI.LOINumber}}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="font-weight: bold;">दिनांक:</span>
                </td>
                <td>
                  <span>{{LOI.LOIDate}}</span>
                </td>
              </tr>
              <tr />
              <tr>
                <td>
                  <span style="font-weight: bold;">अर्ज क्रमांक:</span>
                </td>
                <td>
                  <span>{{LOI.LoanApplicationNo}}</span>
                </td>
              </tr>
              <tr />
            </table>
            <span style="font-size:12.0pt;">प्रति,</span>
            <br />
            <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
              <tr style="width:80%">
                <col />
                <td>
                  <table style="margin-left:0px">
                    <tr>
                      <td style="font-size:12.0pt;font-weight: bold;width:15%">श्री:</td>
                     
                      <td>
                        <span style="font-size:12.0pt;">{{personalDetails.GroupName}}</span>
                      </td>
                    </tr>
                    <tr />
                    <tr>
                      <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                      <td>
                        <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                      </td>
                    </tr>
                    <tr />
                  </table>
                </td>
                <!-- <td>
                  <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
                </td> -->
              </tr>
            </table>
            <br />
            <!-- prati ends -->
  
            <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
              <span style="font-size:12.0pt;">
                प्रिय अध्यक्ष ,
                <br/>
               <b> {{personalDetails.GroupName}}</b>
               
                <br />आपण, महामंडळाच्या  
                <span >महिला स्वयंसिद्धी व्याज परतावा </span>
  
              
              </span>
              <span style="font-size:12.0pt;">
                योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपल्या ऑनलाईन अर्जानुसार {{personalDetails.GroupName}} या बचत गटास आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
              </span>
            </div>
            <!-- priy ends -->
  
            
            <!-- vyav-s ends -->
  
            <!-- <div style="margin-top: 25px; margin-bottom: 25px;" >
              <p
                style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
              >महामंडळाच्या अटी व शर्ती</p> -->
  
              <p style="margin-bottom: 2px;font-size:12.0pt;">
                १. सदर पात्रता प्रमाणपत्र (LOI) हे दि. {{LOI.LOIValidTill}} या तारखेपर्यंत एक वर्ष कालावधीकरीता वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता त्या वर्षाकरीता संपुष्टात येईल.  
              </p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >२. बचत गटातील सदस्यांनी CMRC मार्फत नमुद केलेली अर्जातील माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची महिला स्वयंसिद्धी कर्ज व्याज परतावा योजनेतील कर्ज सवलत रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.  याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड इ. बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज मंजूर करुन घ्यावे. सदरची योजना ही मुदत कर्जासाठी लागु असुन C.C (कॅश क्रेडीट) व O.D (Overdraft) करीता लागु राहणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >५. संबंधित CMRC च्या शिफारशीनुसार महामंडळाच्या प्राप्त पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे. पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत बचत गट योजनेस पात्र ठरणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >६. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर गट हा व्याजपरतावा रक्कमेकरीताच पात्र असेल. इतर मागास प्रवर्गातील किमान 50% महिलांचा समावेश असलेल्या पात्र महिला बचत गटास प्रथम टप्प्यात रु.5.00 लक्षपर्यंत कर्ज बँकेकडून उपलब्ध करुन घेण्यास मान्यता देण्यात येईल व प्रथम टप्प्यातील कर्ज नियमित परतफेडीनंतर सदर बचत गट द्वितीय टप्प्यात रु.10.00 लक्ष पर्यंत कर्ज बँकेकडून मंजूर करुन घेण्यास पात्र होईल.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >७. व्याज परतावा रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल. बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >८. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >९. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. वरील अटी व शर्ती सुधारीत करणे, फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
              <!-- <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >१०. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही, कोणत्याही कारणासाठी महामंडळाविरुध्द नुकसान भरपाईचा हक्क राहणार नाही.</p>
              <p
                style="margin-bottom: 2px;font-size:12.0pt;"
              >११. व्याज रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्राप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल.  बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली रक्कम वगळता दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            </div> -->
            
            <!-- ati ends -->
  
            <div style="display: block; margin-left:50%;text-align:center; ">
              <!-- <span style="font-weight:bold;font-size:12.0pt">Sd/-</span> -->
              <br />
              <!-- <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/> -->
              <span style="font-size:12.0pt;">Sd/-</span><br/>
              <span style="font-size:12.0pt;">महाव्यवस्थापक</span>
              <br />
              <span
                style="font-size:12.0pt;"
              >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्या</span>
              <br />
            </div>
            <!-- vyav-s ends -->
            <!-- <div style="float:center">
              <qr-code 
                  :text=qrtext
                  size="100"
                  error-level="H">
              </qr-code>
            </div>-->
          </div>
          <!-- lio ends -->
        </div>
      </div>
  
    </b-container>
  <!-- new loi -->
  
  
    
  </template>
  
  <script>
  import apis from "@/apis";
  import vueHtmlToPaper from "vue-html-to-paper";
  
  export default {
    props: ["ApplicationID", "Loantype", "UserID", "PastLOI"],
    data() {
      return {
        personalDetails: {},
        LOI: {
          LoanApplicationNo: "",
          ApplicationDate: "",
          ApplicantName: "",
          AdharNo: "",
          Address: "",
          LOIDate: "",
          LOINumber: "",
          BusinessName: "",
          Division: "", //Konkan,
          LOIValidTill: "",
          IsExtended: false,
          SHGName:"",
  
        },
        isLoading: false,
        alertText: "",
        showDismissibleAlert: true,
        variant: "danger",
        qrtext: "this is error",
        size: 100
      };
    },
    methods: {
      print() {
        //window.print();
        this.$htmlToPaper("printLOI");
      },
  
      getImgUrl(pic) {
        //let userinfo = this.$store.getters.loggedUser;
        //let userId = userinfo.UserId;
        if (pic) {
          return (
            "https://aws.msobcfdc.in/S3BucketApril/" +
            this.UserID +
            "/" +
            pic
          );
        }
      },
      processdate(dateStr) {
        // Use a consistent date parsing approach
        const dateParts = dateStr.split(/[-/]/); // Split by either '-' or '/'
        if (dateParts.length === 3) {
          const [year, month, day] = dateParts[0].length === 4 ? dateParts : dateParts.reverse();
          return new Date(`${year}-${month}-${day}`);
        }
        return new Date(dateStr); // Fallback for unexpected formats
      }
    },
  
    mounted() {
      
      //let promiseU = apis.ReadLOI(this.ApplicationID); //Personal Details
      let promiseU;
      if (this.PastLOI) {
        promiseU = apis.ReadPastLOI(this.ApplicationID);
      } else {
        promiseU = apis.ReadLOI(this.ApplicationID);
      }
      promiseU
        .then(response => {
          if (response.status == 200) {
           
  console.log(response.body);
            this.LOI = JSON.parse(response.body);
            console.log(this.LOI);
            this.qrtext =
              "https://msobcfdc.in/verifyloi/" +
              this.ApplicationID +
              "/" +
              this.LOI.LOINumber;
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.isLoading = false;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
        
      let promiseU2 = apis.ReadGroupProfile(this.UserID); //Personal Details
        promiseU2
        .then(response => {
          if (response.status == 200) {
            //console.log(response.body);
            this.personalDetails = response.body.Table[0];
            this.familyDetails = response.body.Table1;
            this.directorDetails = response.body.Table2;
            this.shareholderDetails = response.body.Table3;
            this.form.ApplicationID = this.personalDetails.LoanApplicationID;
          }
        });
    }
  };
  </script>
  
  <style scoped>
  table {
    font-family: arial, sans-serif;
    /* border-collapse: collapse; */
    width: 80%;
    margin-left: 10%;
  }
  
  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 6px;
  }
  .newfont {
    font-size: 0.875rem;
  }
  
  /* aks 06-09-2019 */
  
  .print-button-wrap button {
    color: #fff;
    background-color: #ab7806;
    font-size: 13px;
    font-weight: bold;
    border: none;
    padding: 8px 20px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 4px;
  }
  
  .print-button-wrap {
    margin: auto;
    width: fit-content;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  
  .loi {
    margin-bottom: 50px;
    margin-top: 20px;
  }
  
  .loi,
  .loi p {
    color: #000;
    font-size: 16px;
    font-family: "Laila", serif;
  }
  
  .tobold {
    font-weight: bold;
  }
  
  .loi h2 {
    font-size: 29px;
    text-align: center;
  }
  
  .loi h3 {
    font-size: 22px;
    text-align: center;
    margin-top: 7px;
    margin-bottom: 20px;
  }
  
  .loi .num-date {
    margin-top: 35px;
  }
  
  .loi .app-nm {
    display: inline-block;
    margin-right: 80px;
  }
  
  .loi .prati span {
    display: block;
  }
  
  .loi .prati {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  
  .loi .priy {
    margin-top: 20px;
    margin-bottom: 25px;
  }
  
  .loi .vyav-s span {
    display: block;
    font-weight: bold;
  }
  
  .loi .ati {
    margin-top: 25px;
    margin-bottom: 25px;
  }
  
  .loi .ati h4 {
    font-size: 19px;
    font-weight: bold;
    margin-bottom: 17px;
  }
  
  .loi .ati p {
    margin-bottom: 13px;
  }
  
  /* repsonisve styles */
  
  .loi {
    width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }
  
  @media (max-width: 1199px) {
    .loi {
      width: 80%;
    }
  }
  
  @media (max-width: 767px) {
    .loi {
      width: 90%;
      padding-left: 10px;
      padding-right: 10px;
      margin-top: 15px;
    }
  
    .loi h2 {
      font-size: 24px;
    }
  
    .loi h3 {
      font-size: 20px;
    }
  
    .loi .ati h4 {
      font-size: 18px;
    }
  
    .loi .app-nm {
      margin-right: 0;
      display: block;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/RegistrationLoan/LoanLOIPrint.vue